import React from "react";
import SafetyManager from "./SafetyManager";

const ManagerContext = React.createContext<SafetyManager>(undefined)
export const ManagerProvider = ManagerContext.Provider
export default ManagerContext
